import { ca } from '@cian/analytics';

export function trackAntifraudPopupShow() {
  ca('eventSite', {
    action: 'Show_sopr',
    category: 'CallBack_antifraud_popup',
    label: '/sale/flat/object_type=2/from_developer=1/',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackAntifraudPopupConfirm() {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'CallBack_antifraud_popup',
    label: 'Confirm',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackAntifraudPopupChangePhone() {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'CallBack_antifraud_popup',
    label: 'Change_phone',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackAntifraudPopupResendCode() {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'CallBack_antifraud_popup',
    label: 'Change_Resend_codephone',
    name: 'oldevent',
    useLastProducts: true,
  });
}
